import type { FC } from 'react';
import { Card, SkeletonAvatar, SkeletonLine } from '@george-labs.com/design-system';

import { Highlights } from '@shared/products-components';

const HighlightSkeleton: FC = () => (
    <Card className="text-center">
        <SkeletonAvatar size={SkeletonAvatar.SIZE.SIZE_48} className="mt-3" animated />
        <SkeletonLine level={5} percentageWidth={60} className="mx-auto mt-2" animated />
        <SkeletonLine level={4} percentageWidth={50} className="mx-auto" animated />
    </Card>
);

interface Props {
    'data-cy'?: string;
}

export const HighlightsSkeleton: FC<Props> = ({ 'data-cy': dataCy }) => (
    <Highlights data-cy={dataCy}>
        <HighlightSkeleton />
        <HighlightSkeleton />
    </Highlights>
);
